
import {
  Component, Mixins,
} from 'vue-property-decorator';
import AttachmentsList from '@/components/AttachmentsList.vue';
import TaskStatusAlert from '@/components/TaskStatusAlert.vue';
import TaskActions from '@/components/TaskActions.vue';
import { getLeadCustomValueText } from '@/helpers';
import TaskMixin from '@/mixins/TaskMixin.vue';
import UtilsMixin from '@/mixins/UtilsMixin.vue';
import TaskAttachmentsDialog from '@/components/TaskAttachmentsDialog.vue';

@Component({
  components: {
    AttachmentsList,
    TaskStatusAlert,
    TaskActions,
    TaskAttachmentsDialog,
  },
})
export default class TaskO extends Mixins(TaskMixin, UtilsMixin) {
  // Dialog per la modifica degli allegati (a Task completato)
  editAttachmentsDialog = false

  // Note dell'ordine
  orderNotes: string | null = null

  // Aggiorna i campi con gli eventuali nuovi valori della Lead selezionata
  refreshTask() {
    console.log(`${this.constructor.name}: refreshTask()`); // eslint-disable-line no-console

    this.orderNotes = getLeadCustomValueText(this.selectedLead, 'orderNotes');

    // Richiama il metodo implementato nel mixin
    return this.mixinRefreshTask();
  }

  // I dati extra sono validi?
  get isExtraDataValid(): boolean {
    // Manca l'ordine?
    if (!this.hasAttachments('ordine')) return false;

    // In tutti gli altri casi...
    return true;
  }

  async onEditAttachments() {
    console.log(`${this.constructor.name}: onEditAttachments()`); // eslint-disable-line no-console

    // Seleziona il Task
    await this.$store.dispatch('selectTask', {
      name: 'O',
      leadId: this.selectedLead?.id,
    });

    this.editAttachmentsDialog = true;
  }

  onCloseEditAttachments() {
    console.log(`${this.constructor.name}: onCloseEditAttachments()`); // eslint-disable-line no-console

    // Il dialog è stato chiuso, deseleziona il Task
    this.$store.dispatch('unselectTask');
  }

  // Effetta la validazione del modulo
  async onValidate(status: 'completed' | 'error') {
    console.log(`${this.constructor.name}: onValidate(${status})`); // eslint-disable-line no-console

    // Sceglie se validare il modulo per un completamento o per un fallimento
    this.selectedStatus = status;

    // Avvia l'effettiva validazione
    const form = this.$refs.form as Vue & {
      validate: () => boolean;
      reset: () => boolean;
    };

    if (form) {
      const result = form.validate();
      console.log(`${this.constructor.name}: onValidate() form.validate() =`, result); // eslint-disable-line no-console
    } else {
      console.error(`${this.constructor.name}: onValidate() form =`, form); // eslint-disable-line no-console
      console.error(`${this.constructor.name}: onValidate() this.$refs =`, this.$refs); // eslint-disable-line no-console
    }

    return Promise.resolve();
  }
}
